import React, { Component } from 'react';
import { Route } from 'react-router';
import  HomeInsurance  from './HomePage/HomeInsurance';
import  Quotes from './HomePage/Quotes';
import './custom.css'
import 'font-awesome/css/font-awesome.css';
import Proposal from './HomePage/Proposal';
import Summary from './HomePage/Summary';
import PaymentSuccessOrFailDumy from './components/PaymentSuccessOrFailDumy';
import { Layout } from './components/Layout';
import SharedDataProvider from './components/SharedDataContext';

export default class App extends Component {
  static displayName = App.name;

  render () {
      return (
          <SharedDataProvider>
          <Layout>
                <Route exact path='/' component={HomeInsurance} />
                <Route exact path='/Quotes' component={Quotes} />
                <Route exact path='/Proposal' component={Proposal} />
                <Route exact path='/Summary' component={Summary} />
                <Route exact path='/paymentresult' component={PaymentSuccessOrFailDumy} />
              </Layout>
          </SharedDataProvider>
    );
  }
}
